import { render, staticRenderFns } from "./approvals_footer.vue.js?vue&type=template&id=0dcdf1f3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_footer.vue?vue&type=template&id=0dcdf1f3"
import script from "./approvals_footer.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_footer.vue?vue&type=script&lang=js"
export * from "./approvals_footer.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports